import { GridCellProps } from "@progress/kendo-react-grid";
import * as React from "react";

export default function TimeCell(props: GridCellProps) {
  const { dataItem, field } = props;
  const myField = field || "";
  const dataValue = dataItem[myField] === null ? "" : dataItem[myField];
  if (!dataValue || dataValue === "") {
    return <td />;
  }

  if (dataValue.Hours === 0) dataValue.Hours = "00";
  if (dataValue.Minutes === 0) dataValue.Minutes = "00";
  return <td>{`${dataValue.Hours}:${dataValue.Minutes}`}</td>;
}
